<template>
  <v-container>
    <h2>Set unavailable lesson dates</h2>
    {{ msg }}
    <v-layout class="mt-3" row wrap> 
    <v-flex xs10 sm5 class="mt-3">
      <v-date-picker
        v-model="dates"
        multiple
        first-day-of-week="1"
      ></v-date-picker>
    </v-flex>
    <v-flex xs12 sm6>
      <v-menu
        ref="menu"
        :close-on-content-click="false"
        v-model="menu"
        :nudge-right="40"
        :return-value.sync="dates"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-combobox
          slot="activator"
          v-model="dates"
          multiple
          chips
          small-chips
          label="Disallowed dates"
          prepend-icon="event"
          readonly
        ></v-combobox>
        <v-date-picker v-model="dates" multiple no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
    <v-btn small class="mt-4" color="primary" @click="save">Save dates</v-btn>
    <v-btn small class="ml-4 mt-4" color="secondary" @click="$router.push('/admin')">Cancel</v-btn>
  </v-container>
</template>

<script>
import { format } from "date-fns"
  export default {
    mounted() {
      if (this.disallowedDates.length === 0) {
        this.msg = "You currently have no unavailable dates"
      } else {
        this.msg = `You current unavailable dates are: ${this.disallowedDates}`
      }
    },
    data() {
      return {
        dates: [],
        msg: "",
        menu: false
      }
    },
    computed: {
      disallowedDates() {
        this.$store.getters.getDisallowedDates.pop()
        this.$store.getters.getDisallowedDates.sort((a,b)  => new Date(a) - new Date(b))
        let arr = []
        this.$store.getters.getDisallowedDates.forEach((el) => {
          arr.push(format(el, 'ddd. MMM. D, YYYY'))
        })
        return arr.join(', ')
      }
    },
    methods: {
      save() {
        this.$store.dispatch('setDisallowedDates', this.dates)
      }
    },
  }
</script>

<style scoped>

</style>